'use strict';

angular.module('nfseApp')
    .factory('Guia', function ($resource, DateUtils) {
        return $resource('api/guias/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dataVencimento = DateUtils.convertLocaleDateFromServer(data.dataVencimento);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.dataVencimento = DateUtils.convertLocaleDateToServer(data.dataVencimento);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.dataVencimento = DateUtils.convertLocaleDateToServer(data.dataVencimento);
                    return angular.toJson(data);
                }
            }
        });
    });
